import { makeTable } from "../utils/tables";

export const firstNames = makeTable("firstNames", [
  "Marshal",
  "Tarlow",
  "Cee",
  "Aoi",
  "Niko",
  "Sakura",
  "Naoto",
  "Jun",
  "Ichiro",
  "Koa",
  "Ravi",
  "Mishka",
  "Yuma",
  "Roy",
  "Fushigi",
  "Mateo",
  "Aiko",
  "Ezra",
  "Bo",
  "Elizi",
  "Hina",
  "Iwata",
  "Baker",
  "Bowie",
  "Rowa",
  "Mirai",
  "Kev",
  "Khari",
  "Isa",
  "Lovi",
  "Sura",
  "Anik",
  "Nauja",
  "Sheyma",
  "Mira",
  "Yatin",
  "Yuval",
  "Jienni",
  "Tami",
  "Mufasa",
]);

export const lastNames = makeTable("lastNames", [
  "Grozo",
  "Rife",
  "Shimasu",
  "Aiseke",
  "Helm",
  "Astreio",
  "Tungertok",
  "Casker",
  "Cash",
  "Blaze",
  "Mellowe",
  "Atticus",
  "Dimber",
  "Cage",
  "Rose",
  "Whiz",
  "Zapper",
  "Crow",
  "Cage",
  "Tide",
  "Yamada",
  "Bhat",
  "Ortiz",
  "Behl",
  "Brahm",
  "Oak",
  "Nori",
  "Guide",
  "Bird",
  "Sunn",
  "Lock",
  "Keone",
  "Beconne",
  "Lumen",
  "Canero",
  "Crowne",
  "Home",
  "Rover",
  "Lamassu",
  "Shorell",
]);
